'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.collectTimings = collectTimings;
exports.collectWhenLoaded = collectWhenLoaded;
function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function copyFields(obj) {
    var ret = {}; // performance.timing object is immutable
    // eslint-disable-next-line guard-for-in
    for (var key in obj) {
        var field = obj[key];
        if (isNumeric(field)) {
            ret[key] = obj[key];
        }
    }
    return ret;
}

function getTimings() {
    // performance.timing object is immutable
    var times = copyFields(window.performance.timing);

    // Enhance with time to first paint if possible
    if (times.firstPaint === undefined) {
        if (window.chrome && window.chrome.loadTimes) {
            // Chrome
            times.firstPaint = window.chrome.loadTimes().firstPaintTime * 1000;
        } else if (typeof window.performance.timing.msFirstPaint === 'number') {
            // IE
            times.firstPaint = window.performance.timing.msFirstPaint;
        }
    }

    return times;
}

function sendTimes(url, times) {
    var conn = new XMLHttpRequest();
    conn.open('POST', url);
    conn.setRequestHeader('Content-Type', 'text/json');
    conn.send(JSON.stringify(times));
}

function collectTimings(appName) {
    var reportUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/clientstats.html';

    if (appName) {
        try {
            var times = getTimings();
            times.appName = appName;
            times.path = window.location.pathname;
            sendTimes(reportUrl, times);
        } catch (e) {
            return e;
        }
    }
}

function collectWhenLoaded(appName, reportUrl) {
    window.addEventListener('load', function () {
        window.setTimeout(function () {
            return collectTimings(appName, reportUrl);
        }, 1);
    });
}

//# sourceMappingURL=index.js.map